import { render, staticRenderFns } from "./single-printing.vue?vue&type=template&id=38c4399a&scoped=true&"
import script from "./single-printing.vue?vue&type=script&lang=ts&"
export * from "./single-printing.vue?vue&type=script&lang=ts&"
import style0 from "./single-printing.vue?vue&type=style&index=0&id=38c4399a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c4399a",
  null
  
)

export default component.exports